import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateRowItem($companyId: ID!, $attributes: RowItemAttributes!) {
    createRowItem(companyId: $companyId, attributes: $attributes) {
       rowItem {
        id
        ...CreatedRowItem
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedRowItem on RowItem {
    id
    name
    priceCents
  }
`
